import './App.scss';
import React from 'react';
import { Header } from '../Header/Header';
import { Navigate, Route, Routes } from 'react-router-dom';
import { PersonalMatrixPage } from '../pages/PersonalMatrixPage/PersonalMatrixPage';
import CompatibilityMatrixPage from '../pages/CompatibilityMatrixPage/CompatibilityMatrixPage';
import { MatrixSelectionPage } from '../pages/MatrixSelectionPage/MatrixSelectionPage';
import { IntegrityMatrixPage } from '../pages/IntegrityMatrixPage/IntegrityMatrixPage';
import { YearMatrixPage } from '../pages/YearMatrixPage/YearMatrixPage';

export const App = () => {
  return (
    <>
      {/*<Header />*/}
      <main className="main__wrapper">
        <Routes>
          <Route path="/" element={<MatrixSelectionPage />} />
          <Route path="/personal-matrix" element={<PersonalMatrixPage />} />
          <Route path="/year-matrix" element={<YearMatrixPage />} />
          <Route path="/integrity-matrix" element={<IntegrityMatrixPage />} />
          <Route path="/compatibility-matrix" element={<CompatibilityMatrixPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
    </>
  );
};
